import React, { FunctionComponent } from "react";
import "./QuantityDisclaimerComponent.scss";

const QuantityDisclaimerComponente: FunctionComponent = () => (
  <div className="quantity-disclaimer">
    <p>
      Faltan productos para completar <br className="quantity-disclaimer_br" />{" "}
      orden de pedido:
    </p>
    <p>Compra mínima: 5 oro - 12 Plata</p>
  </div>
);

export default QuantityDisclaimerComponente;
